import React, {useContext} from 'react'
import Button from '@mui/material/Button';
import ConfigContext from '../contexts/configContext'
import DefaultAppLogo from '../images/default-app-logo.svg'
import GetLiveCallPath from './LiveCallPath';

export default function Intro({onStart, onLearnMore}) {
  const config = useContext(ConfigContext)

  return (
    <div className="flex-container">

        <div className="flex-child">
            <img 
                className='live-call-intro-app-logo'
                src={config?.intro?.appLogo 
                    ? config.intro.appLogo
                    : GetLiveCallPath(DefaultAppLogo)
                }
                alt='app logo'
            />
           <p>
            <span style={{fontSize: 60, fontWeight: 'bold'}}>
                {config?.intro?.appHeaderTxt
                    ? config.intro.appHeaderTxt 
                    : "Live Call"
                }
            </span> 
           </p>
        </div>
        
        <div className="flex-child">
            <h2>
                {config?.intro?.headerTxt
                    ? config.intro.headerTxt 
                    : "Expert Advice"
                }
            </h2>
            <p>
                {config?.intro?.mainTxt
                    ? config.intro.mainTxt 
                    : "Join a video or audio only call with a member of our team straight from your web browser and get expert advice right now."
                }
                
            </p>
            <div className='live-call-intro-buttons'>
                <p>
                    <Button 
                        variant="contained"
                        onClick={() => onStart()}
                        size="large"
                    >
                        {config?.intro?.startButtonTxt
                            ? config.intro.startButtonTxt 
                            : "Start Live Call"
                        }
                    </Button>
                </p>
                <p>
                    <Button 
                        variant="outlined"
                        onClick={() => onLearnMore()}
                        size="large"
                    >
                        {config?.intro?.learnButtonTxt
                            ? config.intro.learnButtonTxt 
                            : "Learn More?"
                        }
                    </Button>

                </p>
            </div>
        </div>
    
    </div>
  )
}
